"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectNotInActiveTierError = {
    type: "structure",
    required: [],
    members: {},
    exceptionType: "ObjectNotInActiveTierError"
};
//# sourceMappingURL=ObjectNotInActiveTierError.js.map